import { render, staticRenderFns } from "./TreatmentStepModal.vue?vue&type=template&id=21b3accf&scoped=true"
import script from "./TreatmentStepModal.vue?vue&type=script&lang=ts"
export * from "./TreatmentStepModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3accf",
  null
  
)

export default component.exports